// src/components/Product/DynamicCardProduct.tsx

import { SerpElement } from "@nosto/search-js/preact/serp"
import DynamicCard from "@/elements/DynamicCard/DynamicCard"
import type { Product } from "@/types"

export default function DynamicCardProduct({ product }: { product: Product }) {
  // Skip rendering for skeleton/loading products
  const isSkeleton = product.productId?.startsWith("skeleton-") || product.url === "#"

  if (isSkeleton || !product.handle) {
    return null
  }

  return (
    <SerpElement
      as={DynamicCard}
      hit={{
        productId: product.productId!,
        url: product.url
      }}
      componentProps={{
        handle: product.handle,
        template: "card",
        variantId: product.variantId
      }}
    />
  )
}
